import { render, staticRenderFns } from "./fieldset.vue?vue&type=template&id=0b974f00"
import script from "./fieldset.ts?vue&type=script&lang=js&external"
export * from "./fieldset.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b974f00')) {
      api.createRecord('0b974f00', component.options)
    } else {
      api.reload('0b974f00', component.options)
    }
    module.hot.accept("./fieldset.vue?vue&type=template&id=0b974f00", function () {
      api.rerender('0b974f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/fieldset.vue"
export default component.exports